import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import About from "@/pages/About";
import Testimonials from "@/pages/Testimonials";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminContent from "@/pages/AdminContent";
import AdminContentWysiwyg from "@/pages/AdminContentWysiwyg";
import AdminSettings from "@/pages/AdminSettings";
import AdminAudit from "@/pages/AdminAudit";
import AdminMessages from "@/pages/AdminMessages";
import AdminSchedules from "@/pages/AdminSchedules";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors closeButton />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<Products />} />
                <Route path="/about" element={<About />} />
                <Route path="/testimonials" element={<Testimonials />} />
                <Route path="/contact" element={<Contact />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/content" element={<AdminContentWysiwyg />} />
              <Route path="/admin/content/text" element={<AdminContent />} />
              <Route path="/admin/settings" element={<AdminSettings />} />
              <Route path="/admin/audit" element={<AdminAudit />} />
              <Route path="/admin/messages" element={<AdminMessages />} />
              <Route path="/admin/schedules" element={<AdminSchedules />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
